import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=e21764ee&scoped=true&"
import script from "./guide.vue?vue&type=script&lang=ts&"
export * from "./guide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21764ee",
  null
  
)

export default component.exports